"use strict";
// ── Connection ──
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTikTokAdsDraft = exports.countTikTokAdsLeadFormCustomQuestions = exports.MAX_TIKTOK_ADS_LEAD_FORM_CUSTOM_QUESTIONS = exports.TikTokAdsLeadFormQuestionType = exports.TIKTOK_ADS_OPTIMIZATION_EVENTS = exports.TikTokAdsOptimizationEvent = exports.TIKTOK_ADS_MAX_AD_TEXT_LENGTH = exports.TIKTOK_ADS_MIN_DAILY_BUDGET = exports.TIKTOK_ADS_CTA_OPTIONS = exports.TIKTOK_ADS_AGE_GROUPS = exports.TikTokAdsGender = exports.TikTokAdsPlacementType = exports.TikTokAdsBillingEvent = exports.TikTokAdsOptimizationGoal = exports.TikTokAdsBudgetMode = exports.TIKTOK_ADS_TOPVIEW_MIN_DAILY_BUDGET = exports.TikTokAdsObjective = exports.TikTokAdsProductType = exports.TIKTOK_ADS_REPORT_RANGES = void 0;
exports.TIKTOK_ADS_REPORT_RANGES = [7, 14, 30, 90];
// ── Campaign creation ──
/**
 * Auction In-Feed is the default path. TopView uses Reservation inventory
 * (RF_REACH + /adgroup/rf/create/) on live accounts.
 */
var TikTokAdsProductType;
(function (TikTokAdsProductType) {
    TikTokAdsProductType["IN_FEED"] = "IN_FEED";
    TikTokAdsProductType["TOPVIEW"] = "TOPVIEW";
})(TikTokAdsProductType || (exports.TikTokAdsProductType = TikTokAdsProductType = {}));
/** Values are the literal `objective_type` strings the Marketing API expects. */
var TikTokAdsObjective;
(function (TikTokAdsObjective) {
    TikTokAdsObjective["REACH"] = "REACH";
    TikTokAdsObjective["TRAFFIC"] = "TRAFFIC";
    TikTokAdsObjective["VIDEO_VIEWS"] = "VIDEO_VIEWS";
    TikTokAdsObjective["ENGAGEMENT"] = "ENGAGEMENT";
    TikTokAdsObjective["LEAD_GENERATION"] = "LEAD_GENERATION";
    TikTokAdsObjective["WEB_CONVERSIONS"] = "WEB_CONVERSIONS";
})(TikTokAdsObjective || (exports.TikTokAdsObjective = TikTokAdsObjective = {}));
/** Suggested daily budget floor when the wizard product type is TopView. */
exports.TIKTOK_ADS_TOPVIEW_MIN_DAILY_BUDGET = 500;
var TikTokAdsBudgetMode;
(function (TikTokAdsBudgetMode) {
    TikTokAdsBudgetMode["DAILY"] = "BUDGET_MODE_DAY";
    TikTokAdsBudgetMode["LIFETIME"] = "BUDGET_MODE_TOTAL";
})(TikTokAdsBudgetMode || (exports.TikTokAdsBudgetMode = TikTokAdsBudgetMode = {}));
var TikTokAdsOptimizationGoal;
(function (TikTokAdsOptimizationGoal) {
    TikTokAdsOptimizationGoal["REACH"] = "REACH";
    TikTokAdsOptimizationGoal["CLICK"] = "CLICK";
    TikTokAdsOptimizationGoal["VIDEO_VIEW"] = "VIDEO_VIEW";
    TikTokAdsOptimizationGoal["ENGAGED_VIEW"] = "ENGAGED_VIEW";
    /**
     * Post likes/comments/shares for the ENGAGEMENT objective.
     * TikTok's enum is misspelled as POST_ENGAGEMNT (no second E).
     */
    TikTokAdsOptimizationGoal["POST_ENGAGEMENT"] = "POST_ENGAGEMNT";
    TikTokAdsOptimizationGoal["LEAD_GENERATION"] = "LEAD_GENERATION";
    TikTokAdsOptimizationGoal["CONVERT"] = "CONVERT";
})(TikTokAdsOptimizationGoal || (exports.TikTokAdsOptimizationGoal = TikTokAdsOptimizationGoal = {}));
var TikTokAdsBillingEvent;
(function (TikTokAdsBillingEvent) {
    TikTokAdsBillingEvent["CPC"] = "CPC";
    TikTokAdsBillingEvent["CPM"] = "CPM";
    TikTokAdsBillingEvent["OCPM"] = "OCPM";
    TikTokAdsBillingEvent["CPV"] = "CPV";
})(TikTokAdsBillingEvent || (exports.TikTokAdsBillingEvent = TikTokAdsBillingEvent = {}));
var TikTokAdsPlacementType;
(function (TikTokAdsPlacementType) {
    TikTokAdsPlacementType["AUTOMATIC"] = "PLACEMENT_TYPE_AUTOMATIC";
    TikTokAdsPlacementType["MANUAL"] = "PLACEMENT_TYPE_NORMAL";
})(TikTokAdsPlacementType || (exports.TikTokAdsPlacementType = TikTokAdsPlacementType = {}));
var TikTokAdsGender;
(function (TikTokAdsGender) {
    TikTokAdsGender["UNLIMITED"] = "GENDER_UNLIMITED";
    TikTokAdsGender["MALE"] = "GENDER_MALE";
    TikTokAdsGender["FEMALE"] = "GENDER_FEMALE";
})(TikTokAdsGender || (exports.TikTokAdsGender = TikTokAdsGender = {}));
exports.TIKTOK_ADS_AGE_GROUPS = [
    "AGE_13_17",
    "AGE_18_24",
    "AGE_25_34",
    "AGE_35_44",
    "AGE_45_54",
    "AGE_55_100",
];
exports.TIKTOK_ADS_CTA_OPTIONS = [
    "LEARN_MORE",
    "SHOP_NOW",
    "SIGN_UP",
    "CONTACT_US",
    "BOOK_NOW",
    "APPLY_NOW",
    "GET_QUOTE",
    "ORDER_NOW",
    "DOWNLOAD_NOW",
    "WATCH_NOW",
];
/**
 * TikTok enforces a floor per ad group and per campaign; below this the API
 * rejects the create outright, so the wizard blocks it client-side too.
 */
exports.TIKTOK_ADS_MIN_DAILY_BUDGET = 20;
exports.TIKTOK_ADS_MAX_AD_TEXT_LENGTH = 100;
/**
 * Common TikTok Pixel optimization events for WEB_CONVERSIONS.
 * Values match Marketing API `optimization_event`.
 */
var TikTokAdsOptimizationEvent;
(function (TikTokAdsOptimizationEvent) {
    TikTokAdsOptimizationEvent["COMPLETE_PAYMENT"] = "COMPLETE_PAYMENT";
    TikTokAdsOptimizationEvent["FORM"] = "FORM";
    TikTokAdsOptimizationEvent["CONTACT"] = "CONTACT";
    TikTokAdsOptimizationEvent["COMPLETE_REGISTRATION"] = "COMPLETE_REGISTRATION";
    TikTokAdsOptimizationEvent["PLACE_AN_ORDER"] = "PLACE_AN_ORDER";
    TikTokAdsOptimizationEvent["ADD_TO_CART"] = "ADD_TO_CART";
    TikTokAdsOptimizationEvent["CLICK_BUTTON"] = "CLICK_BUTTON";
    TikTokAdsOptimizationEvent["VIEW_CONTENT"] = "VIEW_CONTENT";
    TikTokAdsOptimizationEvent["DOWNLOAD"] = "DOWNLOAD";
    TikTokAdsOptimizationEvent["SUBSCRIBE"] = "SUBSCRIBE";
})(TikTokAdsOptimizationEvent || (exports.TikTokAdsOptimizationEvent = TikTokAdsOptimizationEvent = {}));
exports.TIKTOK_ADS_OPTIMIZATION_EVENTS = Object.values(TikTokAdsOptimizationEvent);
var TikTokAdsLeadFormQuestionType;
(function (TikTokAdsLeadFormQuestionType) {
    TikTokAdsLeadFormQuestionType["EMAIL"] = "EMAIL";
    TikTokAdsLeadFormQuestionType["FULL_NAME"] = "FULL_NAME";
    TikTokAdsLeadFormQuestionType["PHONE_NUMBER"] = "PHONE_NUMBER";
    TikTokAdsLeadFormQuestionType["CUSTOM"] = "CUSTOM";
})(TikTokAdsLeadFormQuestionType || (exports.TikTokAdsLeadFormQuestionType = TikTokAdsLeadFormQuestionType = {}));
exports.MAX_TIKTOK_ADS_LEAD_FORM_CUSTOM_QUESTIONS = 3;
const countTikTokAdsLeadFormCustomQuestions = (questions) => questions.filter((q) => q.type === TikTokAdsLeadFormQuestionType.CUSTOM)
    .length;
exports.countTikTokAdsLeadFormCustomQuestions = countTikTokAdsLeadFormCustomQuestions;
var tiktok_ads_validate_1 = require("./tiktok-ads-validate");
Object.defineProperty(exports, "validateTikTokAdsDraft", { enumerable: true, get: function () { return tiktok_ads_validate_1.validateTikTokAdsDraft; } });
